// extracted by mini-css-extract-plugin
export var arrows = "_24-6";
export var decrementer = "_24-a";
export var disabled = "_24-4";
export var error = "_24-1";
export var hiddenText = "_24-b";
export var incrementer = "_24-9";
export var input = "_24-8";
export var inputWrapper = "_24-0";
export var leadingIcon = "_24-c";
export var readonly = "_24-3";
export var regular = "_24-7";
export var small = "_24-5";
export var warning = "_24-2";